<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row class="justify-center align-center fill-height">
      <v-progress-circular
        indeterminate
        :color="props.color"
        :size="props.size"
      />
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
const props = defineProps<{
  size: string;
  color: string;
}>();
</script>
